export default "__VITE_ASSET__DCot3U_U__"